import React, { useState, useEffect } from "react";
import "../styles/Sidebar.css";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecordRounded";
import CreateIcon from "@material-ui/icons/Create";
import InsertCommentIcon from "@material-ui/icons/InsertCommentRounded";
import SidebarOption from "./SidebarOption";
import InboxIcon from "@material-ui/icons/Inbox";
import ExpandMoreIcon from "@material-ui/icons/ExpandMoreRounded";
import AddIcon from "@material-ui/icons/Add";
import db from "../firebase.js";
import { auth } from "../firebase";
import { useHistory } from "react-router-dom";
import { useStateValue } from "../StateProvider";

function Sidebar() {
  const [channels, setChannels] = useState([]);
  const [{ user }] = useStateValue();
  const history = useHistory();

  const logOut = () => {
    auth.signOut().then(() => {
      alert(`You've logged out`);
      history.push('/signout');
    }).catch((error) => {
      alert(error.message);
    })
  }


  useEffect(() => {
    // Run this code once when the sidebar components loads
    db.collection("rooms").onSnapshot((snapshot) =>
      setChannels(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          name: doc.data().name,
        }))
      )
    );
  }, []);

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-info">
          <h2>Transformers</h2>
          <h3>
            <FiberManualRecordIcon />
            {user?.displayName}
          </h3>
        </div>
        <CreateIcon />
      </div>
      <SidebarOption Icon={InsertCommentIcon} title="Threads" />
      <SidebarOption Icon={InboxIcon} title="Mentions &amp; Reactions" />
      <hr />
      <SidebarOption Icon={ExpandMoreIcon} title="Channels" />
      <hr />
      <SidebarOption
        Icon={AddIcon}
        addChannelOption
        title="Add Channel"
      />

      {/* Connect to dB and list all the channels */}
      {/* SidebarOption adds */}

      {channels.map(channel => (
      <SidebarOption title={channel.name} id={channel.id}/>
      ))}

      <button className="sidebar-logout" onClick={logOut}>Log Out</button>
    </div>
  );
}

export default Sidebar;
